/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/info';
type status = '3' | '-2'
type p5_role_id = string //  角色GUID
type p3_bre_id = number
type p4_node_id = number


export interface request {
  p5_role_id: p5_role_id,
}

export interface AxiosResponse extends AxiosResponse<responseExtends> { }

interface responseExtends extends backendResponse {
  response: response
}

export type response = {
  role: role,
  node: node[],
  role_node: role_node[]
}

type role = {
  p3_bre_code: number
  p5_role_id: string
  p3_bre_id: p3_bre_id
  p3_bre_list_reject: string
  p3_bre_memo: string
  p3_bre_name: string
  p3_bre_p3_bch_id: number
  p3_bre_sort: number
  p3_bre_specific: string
  p3_bre_status: status
}

export type node = {
  crud: number
  p3_bne_id: number
  p3_bne_name: string
  p3_bne_p3_bch_id: number
  p3_bne_p4_node_id: p4_node_id
  p4_node: p4_node
}

export type p4_node = {
  p4_node_code: string
  p4_node_id: p4_node_id
  p4_node_memo: string
  p4_node_name: string
  p4_node_pid: number
  p4_node_route: string
  p4_node_sort: number
  p4_node_status: status
}

export type role_node = {
  p3_brn_p3_bre_id: p3_bre_id // 角色ID
  p3_brn_p4_node_id: p4_node_id // 節點ID
  crud: number // 權限
  p3_bre_code: null
  p5_role_id: string // 角色GUID
  p3_bre_id: p3_bre_id // 角色ID
  p3_bre_list_reject: string
  p3_bre_memo: null // 角色備註
  p3_bre_name: string // 角色名稱
  p3_bre_p3_bch_id: number
  p3_bre_sort: number // 角色排序
  p3_bre_specific: string
  p3_bre_status: status // 角色狀態
  p3_brn_id: number
}
